import React from "react";
import {
  MenuAccordion,
  MenuCard,
  MenuList,
  MenuListWithImage,
} from "components/MenuLayout";
import classnames from "classnames";
import { CategoryWithRelations } from "Types";
import { useStylesContext } from "context/StylesContext";
import { useMenuContext } from "context/MenuContext";

interface Props {
  category: CategoryWithRelations;
  index: number;
}
const MenuCategory: React.FC<Props> = ({ category }) => {
  const { windowSize } = useStylesContext();
  const isSmallMobile = windowSize.innerWidth < 360;
  const { menuLayout = "CARD" } = useMenuContext();

  const sectionclassname = classnames({
    "w-full justify-center flex flex-wrap gap-8 sm:gap-x-4":
      true,
    "sm:grid sm:grid-cols-2 md:grid-cols-1":
      category.card_type === "normal",
    "grid grid-cols-2 gap-x-4 max-w-[420px] ml-auto mr-auto sm:max-w-full sm:grid-cols-3 md:grid-cols-2":
      category.card_type === "small" && isSmallMobile === false,
  });

  return (
    <section
      id={category.id}
      className="scroll-my-20 w-full pb-8"
    >
      <div className="uppercase font-semibold py-4 text-center text-lg sm:text-left">
        {category.title}
      </div>
      {menuLayout === "CARD" ? (
        <div className={sectionclassname}>
          {category.productsOrder.map((item) => (
            <MenuCard
              key={item.id}
              item={item.product}
              cardType={isSmallMobile ? "normal" : category.card_type}
            />
          ))}
        </div>
      ) : (
        <ul>
          {category.productsOrder.map((item) => (
            <li className="relative" key={item.id}>
              {menuLayout === "LIST" && <MenuList item={item.product} />}
              {menuLayout === "LIST_WITH_IMAGE" && (
                <MenuListWithImage item={item.product} />
              )}
              {menuLayout === "ACCORDION" && (
                <MenuAccordion item={item.product} />
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default MenuCategory;
